import CONSTANTS from "./constants";

export const setActiveFolderIdAction = (payload) => {
  return {
    type: CONSTANTS.ACTIVE_COURSE_CONTENT_FOLDER_ID,
    payload,
  };
};

export const getFreeCourseContentAction = (payload) => {
  return {
    type: CONSTANTS.GET_FREE_COURSE_CONTENT,
    payload,
  };
};

export const getFreeCourseContentLoadMoreAction = (payload) => {
  return {
    type: CONSTANTS.GET_FREE_COURSE_CONTENT_LOAD_MORE,
    payload,
  };
};

export const getCourseContentAction = (payload) => {
  return {
    type: CONSTANTS.GET_COURSE_CONTENT,
    payload,
  };
};

export const getCourseContentLoadMoreAction = (payload) => {
  return {
    type: CONSTANTS.GET_COURSE_CONTENT_LOAD_MORE,
    payload,
  };
};

export const getTrialCourseContentAction = (payload) => {
  return {
    type: CONSTANTS.GET_TRIAL_COURSE_CONTENT,
    payload,
  };
};

export const geTrialCourseContentLoadMoreAction = (payload) => {
  return {
    type: CONSTANTS.GET_TRIAL_COURSE_CONTENT_LOAD_MORE,
    payload,
  };
};

export const getCourseContentTestStatsAction = (payload) => {
  return {
    type: CONSTANTS.GET_COURSE_CONTENT_TEST_STATS,
    payload,
  };
};

export const addPreviewVideoContentAction = (payload) => {
  return {
    type: CONSTANTS.ADD_PREVIEW_VIDEO_CONTENT,
    payload,
  };
};

export const showNotesModalAction = (payload) => {
  return {
    type: CONSTANTS.SHOW_NOTES_MODAL,
    payload,
  };
};

export const setNotesModalContentAction = (payload) => {
  return {
    type: CONSTANTS.SET_NOTES_MODAL_CONTENT,
    payload,
  };
};

export const getContentAttachmentsAction = (payload) => {
  return {
    type: CONSTANTS.GET_CONTENT_ATTACHMENTS,
    payload,
  };
};

export const idfyPrepurchaseOtpGenerateAction = (payload) => {
  return {
    type: CONSTANTS.IDFY_PREPURCHAGE_OTP_GENERATE,
    payload,
  };
};

export const idfyPrepurchageOtpVerifyAction = (payload) => {
  return {
    type: CONSTANTS.IDFY_PREPURCHAGE_OTP_VERIFY,
    payload,
  };
};

export const idfyPostPurchageIdentityVerifyAction = (payload) => {
  return {
    type: CONSTANTS.IDFY_POSTPURCHAGE_IDENTITY_VERIFY,
    payload,
  };
};


export const polingSubmitIdfyDocAction = payload => ({
    type: CONSTANTS.polingSubmitIdfyDoc,
    payload
});

export const idfyPrepurchageModalCloseAction = () => ({
    type: CONSTANTS.IDFY_PREPURCHAGE_OTP_GENERATE_STATE,
})


export const getContentMarkAsDoneAction = (payload) => {
  return {
    type: CONSTANTS.GET_CONTENT_MARK_AS_DONE,
    payload,
  };
};

export const markContentAsDoneAction = (payload) => {
  return {
    type: CONSTANTS.MARK_CONTENT_AS_DONE,
    payload,
  };
};

export const patchContentMarkAsDoneAction = (payload) => {
  return {
    type: CONSTANTS.PATCH_CONTENT_MARK_AS_DONE,
    payload,
  };
};